import Spinner from '@alexis/components/Spinner';

import styles from './UserLoading.module.scss';

const UserLoading = () => {
  return (
    <div className={styles.loadingWrapper}>
      <Spinner className={styles.spinner} />
    </div>
  );
};

export default UserLoading;
